/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedTrackingContainer_user$ref = any;
export type SbSharedTrackingContainer_user$ref = any;
export type SbSharedTrackingContainer_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": SharedTrackingContainer_user$ref;
    readonly " $refType": SbSharedTrackingContainer_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedTrackingContainer_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SharedTrackingContainer_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ed8c22748cc9074e7803de32918e8933';
export default node;
